var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"centered"},[_c('Feed',{ref:"feed",attrs:{"id":_vm.id,"check":true},on:{"postData":function($event){_vm.postData=$event}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }